/* tslint:disable */
/* eslint-disable */
/**
 * MINDD Survey API Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AgreementStatus = {
    None: 'NONE',
    NotAgreed: 'NOT_AGREED',
    Agreed: 'AGREED'
} as const;

export type AgreementStatus = typeof AgreementStatus[keyof typeof AgreementStatus];



